export default "__VITE_ASSET__DO4yFLkG__"